import { useLanguage } from '../../../../../../contexts/LanguageContext';

const WarrantyStatusBanner = ({ startDate, endDate, checkDate }) => {
    const { t } = useLanguage();
    if (!startDate || !endDate) return null;

    const sDate = new Date(startDate);
    const eDate = new Date(endDate);
    const cDate = checkDate ? new Date(checkDate) : new Date();
    const isWarrantyActive = cDate >= sDate && cDate <= eDate;

    const bannerStyle = {
        width: '100%',
        padding: '1rem',
        marginBottom: '1.5rem',
        borderRadius: '8px',
        backgroundColor: isWarrantyActive ? '#d4edda' : '#f8d7da',
        color: isWarrantyActive ? '#155724' : '#721c24',
        border: `1px solid ${isWarrantyActive ? '#c3e6cb' : '#f5c6cb'}`,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '1.1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem'
    };

    return (
        <div style={bannerStyle}>
            <i className={`pi ${isWarrantyActive ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ fontSize: '1.5rem' }}></i>
            {isWarrantyActive
                ? t('warranty.customerDeclaration.status.warrantyContinues') || 'Karsan Garantisi Devam Ediyor'
                : t('warranty.customerDeclaration.status.warrantyExpired') || 'Karsan Garantisi Devam Etmiyor'}
        </div>
    );
};
export default WarrantyStatusBanner;